import {OptionCost} from './OptionCost';

export class SummaryOption {
  public id?: number;
  public name: string;
  public indent = 1;
  public type: string;
  public fabricCollection: string;
  public fabric: string;
  public isFabric = false;
  public fabricColor: string;
  public firstParent?: number;
  public summarySubOptions: string[] = [];
  public summarySubFabrics?: string;
  public cost: OptionCost = new OptionCost();
  public customerPrice: number;
  public dealerPrice: number;
  public amount = 0;
  public products: number[] = [];
  public product: number;
  public random: number;
  public childOptions: number[] = [];
  public needsFabric: boolean;
  public fabricAmount?: number;
  public perProduct = false;
  /**
   * A rug's Size / Shape / Finishing / Colour row (D7/D8). Those rows show what the
   * carpet formula already charged on the product row, so they are a BREAKDOWN: they
   * must never be accumulated into a line or order total, and they are rebuilt from
   * scratch on every recompute. Identifying them by option id does not work — the row
   * carries the selected leaf's id while carpetRole sits on the parent group.
   */
  public carpetComponent = false;
  /** Mirrors Option.requiresCustomerDetails - see needsPosDetails() in the order screen. */
  public requiresCustomerDetails?: boolean;
  public parent?: number;
}
